module.exports = __webpack_public_path__ + "img/Slider_Unternehmen_Weltweit_Mobil.jpg";